import React from 'react';
const Noadmin = () => (
	<div className='role '>
		Role
	</div>
);

export default Noadmin;


// WEBPACK FOOTER //
// ./src/components/Noadmin/Noadmin.js